<template>
  <RevButtonBase
    :aria-label="COMPANY_NAME"
    :class="{ 'cursor-default': !!redirectRoute }"
    :to="redirectRoute"
    :tracking="{ name: 'logo', zone: 'header' }"
  >
    <RevIllustration
      :alt="COMPANY_NAME"
      :height="16"
      src="/img/header/Logo.svg"
      :width="124"
    />
  </RevButtonBase>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'

import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevIllustration } from '@ds/components/Illustration'
import type { Location } from '@ds/types/Location'

defineProps<{ redirectRoute?: Location | string }>()

const runtimeConfig = useRuntimeConfig()
const { COMPANY_NAME } = runtimeConfig.public
</script>
